<template>
  <div class="col-inner p-3 bg-white rounded">
    <div class="d-md-flex gap-3">
      <div class="col-md-3">
        <a :href="`/auctions/${this.auction_id}/lots/${lot.id}`">
          <img
            :src="lot.images.length > 0 ? `/storage/${lot.images[0].path}` : '/images/cars/no_image.jpg'"
            class="img-fluid card-img"
            alt="car"
          >
        </a>
      </div>
      <div class="col">
        <h5 class="black-small-heading">
          <a :href="`/auctions/${this.auction_id}/lots/${lot.id}`">
            {{ lot.car.name }}
          </a>
        </h5>
        <span class="mb-2 font-s14 fw-bold-500 d-block text-start fst-italic">
          {{ lot.car.subtitle }}
        </span>
        <div class="row ">
          <div class="col-12 col-xl-7 ">
            <div v-if="auction_type === 'open'" class="d-flex gap-2 my-2" role="group" aria-label="Basic example">
              <a
                role="button"
                class="extra-rounded text-center btn-lg btn-primary dark-button"
                @click="newRate(lot.id, lot.rate + 500)"
                :ref="'btnLot500' + lot.id"
              >
                {{ trans('rates.add500') }}
              </a>
              <a
                role="button"
                class="extra-rounded text-center btn-lg btn-primary dark-button"
                @click="newRate(lot.id, lot.rate + 1000)"
                :ref="'btnLot1000' + lot.id"
              >
                {{ trans('rates.add1000') }}
              </a>
              <a
                role="button"
                class="extra-rounded text-center btn-lg btn-primary dark-button"
                @click="newRate(lot.id, lot.rate + 2000)"
                :ref="'btnLot2000' + lot.id"
              >
                {{ trans('rates.add2000') }}
              </a>
            </div>
            <div class="d-flex gap-2 my-2" role="group" aria-label="Basic example">
              <span class="font-s14 align-self-center fw-bold-500 back-text min-width-65">Fastbud</span>
              <input
                type="text"
                class="form-control"
                id="Fastbud"
                aria-describedby="Fastbud"
                v-model="rate"
              >
              <a
                role="button"
                class="px-10-py-5 main-group-btn align-self-center text-center btn-primary extra-rounded dark-button"
                @click="newRate(lot.id, rate)"
                :ref="'btnLotManual' + lot.id"
              >
                {{ trans('rates.add_manual') }}
              </a>
            </div>
            <div v-if="auction_type === 'open'" class="d-flex gap-2 my-2" role="group" aria-label="Basic example">
              <span class="font-s14 align-self-center fw-bold-500 back-text min-width-65">Autobud</span>
              <input
                type="text"
                class="form-control"
                id="Maksbud"
                aria-describedby="Maksbud"
                placeholder="Maksbud"
                v-model="autoRate"
              >
              <a
                role="button"
                class="px-10-py-5 main-group-btn align-self-center text-center btn-primary extra-rounded dark-button"
                @click="newAutoRate(lot.id)"
                :ref="'btnLotAutoRate' + lot.id"
              >
                {{ trans('rates.add_auto') }}
              </a>
            </div>
            <div v-if="error !== undefined" class="row  mt-2">
              <div class="col-12">
                <div class="alert alert-danger" role="alert">

                  {{ error }}

                </div>
              </div>
            </div>
          </div>
          <!--          Høyeste bud-->
          <div class="col-12 col-xl-5 ">
            <div v-if="lot.rate !== undefined && auction_type === 'open'" class="row light-bg extra-rounded my-2  mx-0">
              <div class="col-6 px-0">
                <span class="font-s14 px-2 py-2 d-block text-start fw-bold-600">Høyeste bud</span>
              </div>
              <div class="col-6 px-0">
                <span class="font-s14 px-2 py-2 d-block text-end fw-bold-600">
                   <transition name="text" mode="out-in">
                            <div class="d-inline" :key="lot.rate">
                                {{ new Intl.NumberFormat('ru-RU').format(lot.rate) }}
                            </div>
                        </transition>
                  <br/>
                        <strong v-if="lot.show_message_rate && lot.me_rate" class="text-success">(mitt bud)</strong>
                </span>
              </div>
              <div v-if="lot.show_message_rate && !lot.me_rate" class="col-12 px-0 ">
                <span class="font-s14 px-2 pb-2 d-block text-end fw-bold-600">
                  <strong class="text-danger">(du har blitt overbudt!)</strong>
                </span>
              </div>
            </div>
            <!--            Ditt siste bud-->
            <div class="d-flex light-bg extra-rounded my-2">
              <div class="col-8">
                <span class="font-s14 px-2 py-2 d-block text-start fw-bold-600">Ditt siste bud</span>
              </div>
              <div class="col-4">
                <span class="font-s14 px-2 py-2 d-block text-end fw-bold-600">
                  {{
                    lot.rates !== undefined && lot.rates[0] !== undefined ? new Intl.NumberFormat('ru-RU').format(lot.rates[0].rate) : '0'
                  }}
                </span>
              </div>
            </div>
            <!--            Ditt autobud-->
            <div
              v-if="lot.auto_rates !== undefined && lot.auto_rates[0] !== undefined && lot.auto_rates[0].rate >= lot.rate"
              class="d-flex light-bg extra-rounded my-2"
            >
              <div class="col-8">
                <span class="font-s14 px-2 py-2 d-block text-start fw-bold-600">Ditt autobud</span>
              </div>
              <div class="col-4">
                <span class="font-s14 px-2 py-2 d-block text-end fw-bold-600">
                     {{ new Intl.NumberFormat('ru-RU').format(lot.auto_rates[0].rate) }}
                </span>
              </div>
            </div>
            <div
              v-if="lot.show_min_price"
              class="d-flex light-bg extra-rounded my-2"
            >
              <div class="col-8">
                <span class="font-s14 px-2 py-2 d-block text-start fw-bold-600">Minstepris</span>
              </div>
              <div class="col-4">
                <span class="font-s14 px-2 py-2 d-block text-end fw-bold-600">
                       {{ new Intl.NumberFormat('ru-RU').format(lot.car.reserve_price) }}
                </span>
              </div>
            </div>
            <div class="d-block light-bg extra-rounded my-2">
              <timer-component
                :time="time"
                :time_end="lot.time_end"
                :time_destroy="1"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TimerComponent from "../TimerComponent";

export default {
  components: {TimerComponent},
  mounted() {
  },
  props: ['lot', 'time', 'auction_id', 'auction_type'],
  data() {
    return {
      error: undefined,
      rate: '',
      autoRate: ''
    }
  },
  methods: {
    newRate(lot_id, amount) {
      this.error = undefined
      axios({
        url: `/auctions/${this.auction_id}/lots/ajax/${lot_id}`,
        method: 'PUT',
        data: {amount: amount}
      }).then(resp => {
        if (this.auction_type === 'close') {
          this.lot.rates = resp.data.lot.rates
        }
      }).catch(err => {
        this.error = err.response.data.message
      })

      this.rate = ''
      if (this.auction_type !== 'close') {
        this.$refs['btnLot500' + lot_id].blur()
        this.$refs['btnLot1000' + lot_id].blur()
        this.$refs['btnLot2000' + lot_id].blur()
      }
      this.$refs['btnLotManual' + lot_id].blur()
    },
    newAutoRate(lot_id) {
      this.error = undefined
      axios({
        url: `/auctions/${this.auction_id}/lots/ajax/${lot_id}/autorate`,
        method: 'PUT',
        data: {amount: this.autoRate}
      }).then(resp => {
        this.lot.rates = resp.data.lot.rates
        this.autoRate = ''
      }).catch(err => {
        this.error = err.response.data.message
      })

      this.rate = ''
      this.$refs['btnLot500' + lot_id].blur()
      this.$refs['btnLot1000' + lot_id].blur()
      this.$refs['btnLot2000' + lot_id].blur()
      this.$refs['btnLotManual' + lot_id].blur()
    },
  }
}
</script>

<style>

</style>
